import React from 'react'
import { useLangContext } from '../context/lang.context'
import { useFormContext } from '../context/form.context'
import { colors, s, alpha } from '../style'
import Spinner from './Spinner'

const FormFeedback = ({
  open,
  setOpen,
  success,
  dataSuccess,
  dataFailure,
  popup,
}) => {
  const { lang } = useLangContext()
  const { setFormOpen } = useFormContext()
  return (
    <div
      css={[
        sBackdrop,
        popup && {
          color: colors.text,
          backgroundColor: colors.white.concat(alpha[95]),
          borderRadius: '2rem 0 0 2rem',
        },
      ]}
      onClick={() => {
        if (setOpen) setOpen(false)
        if (popup) setFormOpen(false)
      }}
      onKeyPress={() => {
        if (setOpen) setOpen(false)
        if (popup) setFormOpen(false)
      }}
      tabIndex={0}
      role='button'>
      <div css={sInner}>
        {success === null && <Spinner />}
        {success === true && (
          <div css={sResponse}>
            {/* <div css={sIcon}>
            <CheckCircleIcon />
          </div> */}
            <p className='response-title'>{dataSuccess?.title[lang]}</p>
            <p className='response-text'>{dataSuccess?.text[lang]}</p>
          </div>
        )}
        {success === false && (
          <div css={sResponse}>
            {/* <div css={sIcon}>
            <BlockIcon />
          </div> */}
            <p className='response-title'>{dataFailure?.title[lang]}</p>
            <p className='response-text'>{dataFailure?.text[lang]}</p>
          </div>
        )}
      </div>
    </div>
  )
}

const sBackdrop = {
  animation: 'fadeIn 0.4s ease-out both alternate',
  zIndex: 1010,
  color: colors.white,
  backgroundColor: colors.text.concat(alpha[95]),
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100vh',
  // [s.hover]: {
  //   backdropFilter: 'blur(32px)',
  //   backgroundColor: colors.text.concat(alpha[30]),
  // },
}

const sInner = {
  width: '100%',
  height: '100%',
  maxWidth: 1500,
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 4rem',
  [s.sm_down]: {
    padding: '0 2rem',
  },
}

const sResponse = {
  p: {
    position: 'relative',
    left: 0,
    right: 0,
  },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  top: 0,
  left: 0,

  '.response-title': {
    fontSize: '3rem',
    paddingBottom: '2rem',
    letterSpacing: '-0.05em',
    fontWeight: 800,
    [s.ss]: { fontSize: '2rem' },
  },
  '.response-text': {
    lineHeight: '1.618em',
    fontSize: '1rem',
    opacity: 0.6,
    padding: '0 2rem',
    textAlign: 'center',
    [s.md]: {
      maxWidth: '60%',
    },
  },
}
// const sIcon = {
//   backgroundColor: 'inherit',
//   zIndex: 0,
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   opacity: 0.16,
//   [s.sm_down]: {
//     width: '100vw',
//     height: '100vw',
//   },
//   [s.md]: {
//     width: '50vw',
//     height: '50vw',
//   },
//   svg: {
//     width: '100%',
//     height: '100%',
//   },
// }

export default FormFeedback
